export const login = (actualToken) => localStorage.setItem('token', actualToken);
export const logout = () => localStorage.removeItem('token');